import React from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';
import { propTypes } from '~/tools/prop_types';

// @ts-expect-error TS(2345): Argument of type '() => { row: { cursor: ({ allowC... Remove this comment to see the full error message
const useStyles = jss.makeStyles(() => ({
  row: {
    cursor: ({ allowClick }) => (allowClick ? 'pointer' : 'default'),
  },
}));

const ClickableTableRow = ({ rowData, rowIndex, onClickRow, children }) => {
  // @ts-expect-error TS(2339): Property 'propTypes' does not exist on type '({ ro... Remove this comment to see the full error message
  ClickableTableRow.propTypes = {
    rowData: propTypes.object.isRequired,
    rowIndex: propTypes.number.isRequired,
    onClickRow: propTypes.func.isRequired,
  };

  const allowClick = !!onClickRow;
  const classes = useStyles({ allowClick });

  const handleClickRow = () => onClickRow && onClickRow(rowData, rowIndex);

  return (
    <mui.TableRow onClick={handleClickRow} hover={allowClick} className={classes.row}>
      {children}
    </mui.TableRow>
  );
};

export default ClickableTableRow;
